<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full">
        <div class="flex flex-wrap mb-4 px-4">
          <multi-select-input v-model="filters.Agency.name" :multiple="true" :options="agenciesSearch"
            class="lg:pr-6 w-full lg:w-1/3" label="Nome" />

          <mask-input class="lg:pr-6 w-full lg:w-1/3" mask="##.###.###/####-##" label="CNPJ"
            v-model="filters.Agency.cnpj" />

          <multi-select-input v-model="filters.Agency.plan" :multiple="true" :options="plansSearch"
            class="w-full lg:w-1/3" label="Plano" />
        </div>
        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs uppercase rounded shadow-md border-solid border-2 border-transparent hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out "
            @click.submit.prevent="pesquisar">
            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
            Pesquisar
          </button>

          <button type="button"
            class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs uppercase border-solid border-2 border-purple-100"
            @click.submit.prevent="clearSearch">
            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
            Limpar
          </button>
        </div>
      </form>
    </div>

    <Head title="Gestão de empresas" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Gestão de empresas</h1>
      <data-table v-if="loadTable" v-model:columns="columns" route="agencies/list" :query="getQuery"
        no-data-label="Nenhuma empresa encontrada" no-result-label="Nenhuma empresa encontrada" class="data-table">
        <template #table.cell.content.status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.status="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 grid-rows-auto gap-4">
            <span @click="openModalEdit(row)" title="Editar"
              class="bg-purple-200 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons edit-button">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" /><span class="btn-label">Editar</span>
            </span>
            <span @click="openModalConfirmDelete(row)" title="Excluir"
              class="bg-red_delete text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons delete-button">
              <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" /><span class="btn-label">Excluir</span>
            </span>
            <span @click="accessAgency(row)" title="Acessar empresa"
              class="btn-purple font-normal col-span-2 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center justify-center action-buttons delete-button">
              <span class="btn-label pr-2">Acessar empresa</span><font-awesome-icon icon="fa-angle-right" class="text-white" />
            </span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4">
            <span @click="openModalEdit(row)"
              class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm py-2 px-4">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm py-2 px-4">
              <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
            </span>
            <span @click="accessAgency(row)" title="Acessar empresa"
              class="btn-purple font-normal col-span-2 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center justify-center action-buttons delete-button">
              <span class="btn-label pr-2">Acessar empresa</span><font-awesome-icon icon="fa-angle-right" class="text-white" />
            </span>
          </div>
        </template>
        <template #after.reload-button>
          <div class="flex flex-col sm:flex-row w-full gap-3">
            <button class="flex justify-center items-end font-roboto font-medium btn-purple uppercase w-full"
              @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="">
                Adicionar Empresa</span>
            </button>
          </div>
        </template>
      </data-table>
    </div>
  </div>
  <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
  <modal-edit ref="modalEdit" title="Empresa" url="agencies" @submitForm="reloadTable">
    <template #form="{item}">
      <div class="w-full text-gray-600 text-lg">Dados da empresa</div>
      <text-input v-model="item.name" :error="item.errors.name" required="true" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome" />
      <mask-input mask="##.###.###/####-##" :clear-incomplete="true" v-model="item.cnpj" :error="item.errors.cnpj" class="w-full lg:w-1/2 mt-6" label="CNPJ" />
      <mask-input mask="####" v-model="item.qt_promoters" :error="item.errors.qt_promoters" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Quantidade de promotores" />
      <select-input v-model="item.plan" :error="item.errors.plan" class="w-full lg:w-1/2 mt-6" label="Definir plano de assinatura">
        <option :value="null"></option>
        <option v-for="(value, name, index) in plans_options" :key="name" :value="name">{{ value }}</option>
      </select-input>
      <div class="w-full mt-6 text-gray-600 text-lg">Dados do responsável da empresa</div>
      <text-input v-model="item.user.name" :error="item.errors[`user.name`]" required="true" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome do responsável" />
      <mask-input mask="###.###.###-##" :clear-incomplete="true" v-model="item.cpf" :error="item.errors.cpf" class="w-full lg:w-1/2 mt-6" label="CPF" />
      <mask-input :mask="['(##) ####-####', '(##) #####-####']" :clear-incomplete="true" v-model="item.phone" :error="item.errors.phone" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Telefone" />
      <text-input v-model="item.user.email" :error="item.errors[`user.email`]" required="true" class="w-full lg:w-1/2 mt-6" label="E-mail" />
      <cep-input @updateAddress="(...args) => this.onUpdateAddress(item.address,...args)" v-model="item.address.postcode" :error="item.errors[`address.postcode`]" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="CEP" />
      <text-input v-model="item.address.street" :error="item.errors[`address.street`]" class="mt-6 w-full lg:w-1/2" label="Logradouro" />
      <text-input v-model="item.address.number" :error="item.errors[`address.number`]" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="Número" />
      <text-input v-model="item.address.complement" :error="item.errors[`address.complement`]" class="mt-6 w-full lg:w-1/2" label="Complemento" />
      <text-input v-model="item.address.neighborhood" :error="item.errors[`address.neighborhood`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Bairro" />
      <text-input v-model="item.address.city" :error="item.errors[`address.city`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Cidade" />
      <select-input v-model="item.address.state" :error="item.errors[`address.state`]" class="mt-6 w-full lg:w-1/3" label="Estado">
        <option :value="null" disabled class="hidden invisible"></option>
        <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
      </select-input>
      <div class="w-full mt-6 text-gray-600 text-lg">Dados de login</div>
      <text-input v-model="item.user.user_name" :error="item.errors[`user.user_name`]" required="true" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome do usuário" />
      <password-input v-model="item.user.password" :error="item.errors[`user.password`]" class="w-full lg:w-1/2 mt-6" :required="item.id ? false : true" :label="item.id ? 'Alterar senha' : 'Senha'" />
      <switch-input v-model="item.auto_inactivate" labelChecked="Caso o contrato acabe inativar automaticamente a empresa" labelUnchecked="Caso o contrato acabe inativar automaticamente a empresa" class="w-full mt-6" />
      <date-input v-model="item.validity" :error="item.errors.validity" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Data de término do contrato" required="true" />
      <switch-input v-model="item.status" :error="item.errors.status" label="Situação" labelChecked="Ativo" labelUnchecked="Inativo" class="w-full lg:w-1/2 mt-6" />

      <div class="w-full mt-6 text-gray-600 text-lg">Configurações de foto</div>
      <text-input v-model="item.time_interval" :error="item.errors.time_interval" required="true" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Intervalo" />
      <select-input v-model="item.time_unit" :error="item.errors.time_unit" class="mt-6 w-full lg:w-1/3" required="true" label="Unidade">
        <option :value="null" disabled class="hidden invisible"></option>
        <option v-for="(option, index) in intervalOptions" :key="index" :value="option.value">{{ option.label }}</option>
      </select-input>
    </template>
  </modal-edit>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import MaskInput from '@/Shared/MaskInput'
import SwitchInput from '@/Shared/SwitchInput'
import CepInput from '@/Shared/CepInput'
import SelectInput from '@/Shared/SelectInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import PasswordInput from '@/Shared/PasswordInput'
import DateInput from '@/Shared/DateInput'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
    MaskInput,
    SwitchInput,
    CepInput,
    SelectInput,
    MultiSelectInput,
    Link,
    PasswordInput,
    DateInput,
  },
  props: {
    states_options: Object,
    plans_options: Object,
    plansSearch: Array,
    agenciesSearch: Array,
  },
  layout: Layout,

  data() {
    return {
      loadTable: true,
      transferLinks: false,

      intervalOptions: [
        { label: 'Dias', value: 'day' },
        { label: 'Semana', value: 'week' },
        { label: 'Meses', value: 'month' },
      ],

      columns: [
        {
          uniqid: 'name',
          label: 'Nome',
          field: 'agencies.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.name ? `${row.name}` : '',
        },
        {
          uniqid: 'cnpj',
          label: 'CNPJ',
          field: 'cnpj',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm col-cnpj',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.cnpj ? `${row.cnpj}` : '',
        },
        {
          uniqid: 'plan_label',
          label: 'Plano',
          field: 'plan_label',
          visible: true,
          sortable: false,
          classes: 'px-4 py-3 border-b text-sm col-email whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4',
          format: (val, row) => row.plan_label ? `${row.plan_label}` : '',
        },
        {
          uniqid: 'status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ]
    }
  },

  computed: {
    getQuery() {
      return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
    },
  },

  methods: {
    filterIds: function (id) {
      return this.$props.promoter_list?.filter(promoter => promoter.id != id)
    },
    handleSelectPromoter: function ($event) {
      this.$refs.modalDelete.setPayload({ id: $event.target.value })
    },
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/agencies/update-status", item);
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable();
    },
    pesquisar() {
      this.reloadTable();
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/agencies/${item.id}`, `Deseja realmente excluir a empresa ${item.name}?`);
    },
    openModalEdit(i) {
      let item = {
        id: i.id,
        name: i.name,
        cnpj: i.cnpj,
        qt_promoters: i.qt_promoters,
        plan: i.plan,
        phone: i.phone,
        cpf: i.cpf,
        status: i.status ?? true,
        auto_inactivate: i.auto_inactivate,
        validity: i.validity,
        user: {},
        address: {},
        time_interval: i.time_interval ?? 1,
        time_unit: i.time_unit ?? '',
      }
      if (i.user) {
        item.user = {
          id: i.user.id,
          name: i.user.name,
          email: i.user.email,
          user_name: i.user.user_name,
        }
      }
      if (i.address) {
        item.address = {
          id: i.address.id,
          street: i.address.street,
          number: i.address.number,
          complement: i.address.complement,
          neighborhood: i.address.neighborhood,
          state: i.address.state,
          city: i.address.city,
          postcode: i.address.postcode,
        }
      }

      this.$refs.modalEdit.openModalEdit(item);
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    onUpdateAddress(address, json) {
      address.city = json.localidade;
      address.state = json.uf;
      address.street = json.logradouro;
      address.neighborhood = json.bairro;
    },
    accessAgency(agency) {
        this.$inertia.post("/agencies/access", {id: agency.id});
    }
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent('Agency')

    const clearFilters = () => clearFiltersComponent('Agency')
    const getFilters = () => getFiltersComponent('Agency')

    return {
      getFilters,
      clearFilters,
      filters: filtersStore.filters
    }
  }
}
</script>

<style scoped></style>
